:host {
    .headline {
        @include typo-ws-h4;

        margin: 0;
    }

    slot {
        margin-top: 25px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }
}
